import { useSelector } from 'react-redux'

import { useIsTutorialPending } from 'routes/Menu/hooks/useIsTutorialPending'
import { getUserOrdersWithRecipes } from 'selectors/user'

import {
  type RecommendationsCollectionForTutorial,
  useShowJFYTutorial,
} from '../JustForYouTutorial/useShowJFYTutorial'

export const MENU_PREFERENCES_TUTORIAL_NAME = 'customised_recipe_tiles_menu_preferences'

export const useShouldShowMenuPreferencesTutorial = (
  recommendationsCollection?: RecommendationsCollectionForTutorial | null,
) => {
  const ordersWithRecipes = useSelector(getUserOrdersWithRecipes)
  const showJFYTutorial = useShowJFYTutorial(recommendationsCollection)
  const isTutorialPending = useIsTutorialPending(MENU_PREFERENCES_TUTORIAL_NAME)

  return Boolean(ordersWithRecipes?.size > 1 && isTutorialPending && !showJFYTutorial)
}
